<template>
  <!-- 员工管理 -->
  <div class="containerbox serverContent">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor glo_bgcMainColor" @click="addServe()">新建</el-button>
        <el-button class="glo_btnItems" @click="clickBorrowing()">开启借支</el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns :MoreConditions="MoreConditions" :showMoreBtns="false" @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" @moreParam="moreParam"></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
        <el-form-item class="queryItems" label="姓名:">
          <el-input clearable v-model="queryData.employeeName" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="工号:">
          <el-input clearable v-model="queryData.jobNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="所属网点:">
          <el-select filterable clearable v-model="queryData.deptId" placeholder="请选择" remote :loading="false" :remote-method="getDeptList" @change="changeDep">
            <el-option v-for="(item, index) in deptNameList" :key="index" :label="item.departmentName" :value="item.deptId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格:height="tableHeigth" -->
    <div class="glo_Table" ref="tableWrapper">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            v-if="item.field == 'employeeStatusShow'"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div style="color: #f00" v-if="scope.row.employeeStatus == 'li_zhi:employee_status'">{{ scope.row.employeeStatusShow }}</div>
              <div v-else>{{ scope.row.employeeStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="120px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="editEmployee(scope.row)">编辑</el-button>
              <el-button class="rbtns" @click.stop="delBtns(scope.row)">删除</el-button>

              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页组件 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :sizeList="sizeList"
      :size="pageTotal"
      class="serverPage"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新建弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form v-if="isShowDialog" class="diaForm" ref="dialogFormRef" :model="dialogForm" label-width="110px" :rules="rulesForm">
          <el-form-item class="dialogFormItems" prop="employeeName" label="姓名:">
            <el-input v-model="dialogForm.employeeName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="employeeStatus" label="在职状态:">
            <el-select filterable clearable v-model="dialogForm.employeeStatus" placeholder="请选择">
              <el-option v-for="(item, index) in employeeStatusLists" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sex" label="性别:">
            <el-select filterable clearable v-model="dialogForm.sex" placeholder="请选择">
              <el-option v-for="(item, index) in SexStatusLists" :key="index" :label="item.showName" :value="item.statusVal"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序">
            <el-input v-model="dialogForm.sort" placeholder="请输入" clearable type="number"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="deptId" label="所属部门:">
            <el-select filterable clearable v-model="dialogForm.deptId" placeholder="请选择" remote :loading="false" :remote-method="getDeptList" @change="changeDep">
              <el-option v-for="(item, index) in deptNameList" :key="index" :label="item.departmentName" :value="item.deptId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="jobNumber" label="工号:">
            <el-input v-model="dialogForm.jobNumber" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="jobNameConfDictId" label="职位:">
            <el-select filterable clearable v-model="dialogForm.jobNameConfDictId" placeholder="请选择">
              <el-option v-for="(item, index) in jobNameList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="groupNameConfDictId" label="组别:">
            <el-select filterable clearable v-model="dialogForm.groupNameConfDictId" placeholder="请选择">
              <el-option v-for="(item, index) in groupNameList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="phone" label="手机:">
            <el-input v-model="dialogForm.phone" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="tel" label="电话:">
            <el-input v-model="dialogForm.tel" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="mail" label="邮箱:">
            <el-input v-model="dialogForm.mail" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="commissionRate" label="提成比例(%):">
            <el-input v-model="dialogForm.commissionRate" placeholder="请输入" clearable type="number"></el-input>
          </el-form-item>

          <el-form-item class="dislogFormTextarea" prop="comment" label="备注:">
            <el-input type="textarea" rows="2" v-model="dialogForm.comment" clearable></el-input>
          </el-form-item>
          <!-- 编辑的 -->
          <template v-if="dialogType == 'edit'">
            <el-form-item class="dialogFormItems" prop="creatorUserName" label="新建人:">
              <el-input v-model="dialogForm.creatorUserName" placeholder="自动带出" disabled></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="createTime" label="新建时间:">
              <el-input v-model="dialogForm.createTime" placeholder="自动带出" disabled></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="updateUserName" label="修改人:">
              <el-input v-model="dialogForm.updateUserName" placeholder="自动带出" disabled></el-input>
            </el-form-item>
            <el-form-item class="dialogFormItems" prop="updateTime" label="修改时间:">
              <el-input v-model="dialogForm.updateTime" placeholder="自动带出" disabled></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form :model="queryData" class="glo_form hasMoreParam" label-position="left">
          <el-form-item class="queryItems" label="姓名:">
            <el-input clearable v-model="queryData.employeeName" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="工号:">
            <el-input clearable v-model="queryData.jobNumber" placeholder="请输入" @keyup.enter.native="queryBtn_ok"></el-input>
          </el-form-item>
          <el-form-item class="queryItems" label="所属网点:">
            <el-select filterable clearable v-model="queryData.deptId" placeholder="请选择" remote :loading="false" :remote-method="getDeptList" @change="changeDep">
              <el-option v-for="(item, index) in deptNameList" :key="index" :label="item.departmentName" :value="item.deptId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>

    <!-- 修改密码 -->
    <!-- <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="diaCancelBtn2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="isShowDialog2"
          ref="dialogForm2"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            style="margin: 70px auto"
            prop="aaa"
            label="新密码:"
          >
            <el-input v-model="dialogForm2.aaa" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>-->
  </div>
</template>

<script>
// import { apiList, this.$API } from "@/assets/js/api";
// import tools from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [exportjs],
  inject: ["reload"],
  components: {
    queryBtns,
    myDialog,
    paging,
    uploadimgs,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "员工管理", //导出时默认文件名
        apiName: "/admin/v3/tms/employee/getEmployeeList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageStart: 1, //页码
      pageTotal: this.$COMMON.pageTotals, //一页几条,
      pageCount: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      tableData: [1, 2, 3], //表格数据
      tableHeigth: "75vh",
      selectMemberData: [],

      queryData: { employeeName: "", jobNumber: "", deptId: "" },
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        employeeName: "",
        employeeStatus: "zai_zhi:employee_status", // zai_zhi:employee_status=在职 li_zhi:employee_status=离职
        sex: "",
        comment: "",
        commissionRate: "", //提成比例
        deptId: "", //部门id
        groupNameConfDictId: "", //组别id
        jobName: "", //职务
        jobNameConfDictId: "", //职位id
        jobNumber: "", //提成比例
        phone: "", //手机
        mail: "", //邮箱
        tel: "", //电话
        sort: "1", //电话
      },
      rulesForm: {
        employeeName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        employeeStatus: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        sex: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        phone: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        jobNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        sort: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      isShowDialog2: false,
      dialogTitle2: "修改密码",
      diaWidth2: "30%",
      dialogForm2: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },

      // upLoadUrl: this.$COMMON.uploadUrl,
      fileNameLists: [],
      pageType: "add",

      className: "",

      // 表格设置
      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "工号",
          field: "jobNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "姓名",
          field: "employeeName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "employeeStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "性别",
          field: "sexShow",
          width: "100",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "职位",
          field: "jobName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "组别",
          field: "groupName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "排序",
          field: "sort",
          width: "80",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "电话",
          field: "tel",
          width: "140",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "手机号",
          field: "phone",
          width: "140",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "邮箱",
          field: "mail",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提成比例",
          field: "commissionRate",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "comment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "creatorUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改人",
          field: "updateUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "修改时间",
          field: "updateTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: "员工管理模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "EmployeeManagement", //  页面标识

      // 在职状态列表
      employeeStatusLists: [
        {
          showName: "在职",
          statusVal: "zai_zhi:employee_status",
          languageCode: "zh-CN",
        },
        {
          showName: "离职",
          statusVal: "li_zhi:employee_status",
          languageCode: "zh-CN",
        },
      ],
      // 性别
      SexStatusLists: [
        {
          showName: "男",
          statusVal: "mam:sex",
          languageCode: "zh-CN",
        },
        {
          showName: "女",
          statusVal: "womom:sex",
          languageCode: "zh-CN",
        },
      ],
      deptNameList: [], //部门
      groupNameList: [], //组别
      jobNameList: [], //岗位

      dialogType: "add",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  mounted() {
    this.getData();
    this.getDeptList();
  },
  activated() {},
  watch: {},
  methods: {
    clickBorrowing() {
      if (this.selectMemberData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      }
      let employeeIds = [];
      this.selectMemberData.forEach((item) => {
        employeeIds.push(item.employeeId);
      });
      this.$confirm("确定要开启借支所选数据吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.startEmployeeJieZhi({ employeeIds }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
    // 获取组别
    getConfDictValDownListGroupName() {
      this.$API
        .wtl_getConfDictValDownList({ dictType: "group_name" })
        .then((res) => {
          this.groupNameList = res.data.result || [];
        });
    },
    // 获取岗位
    getConfDictValDownListJobName() {
      this.$API
        .wtl_getConfDictValDownList({ dictType: "job_name" })
        .then((res) => {
          this.jobNameList = res.data.result || [];
        });
    },
    // 获取员工状态
    getStatusValLists() {
      this.$TOOLS
        .getStatusValList("organization_employee_v1.employee_status")
        .then((res) => {
          this.employeeStatusLists = res || [];
        });
    },
    // 获取性别状态
    getSexStatusLists() {
      this.$TOOLS
        .getStatusValList("organization_employee_v1.sex")
        .then((res) => {
          this.SexStatusLists = res || [];
        });
    },
    // 获取部门(下拉,远程搜索)
    getDeptList(deptName) {
      this.$API
        .wtl_getDeptList({
          deptName: deptName || "",
          pageStart: 1,
          pageTotal: 100,
        })
        .then((res) => {
          this.deptNameList = res.data.result.data || [];
        });
    },
    //部门变化触发
    changeDep(e) {
      if (!e) {
        this.getDeptList();
      }
      this.queryBtn_ok();
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      // a==修改密码
      if (type === "a") {
        this.isShowDialog2 = true;
      }
      // d==删除
      if (type === "d") {
      }
    },

    myModel() {
      this.$TOOLS.myModel(this);
    },

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        this.$TOOLS.myModel(this);
      }

      if (a === "dc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      console.log("1111111");
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    // 删除
    DelServe() {
      if (this.selectMemberData.length < 1) {
        this.$message({
          message: "请至少勾选一条数据",
          type: "warning",
        });
        return false;
      }

      this.$confirm("该操作将永久删除该文章,请谨慎操作!", "提示:")
        .then((res) => {
          let ids = [];
          this.selectMemberData.forEach((item) => {
            ids.push(item.articleId);
          });
          let param = {
            articleId: ids,
          };
          param.sign = "";
          this.$API.deleteArticle(param).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    aaaaaa() {},
    // 分配权限
    AssignMent() {
      this.$router.push({
        path: "/SystemSetting/PermissionAssignmentUser",
        query: {},
      });
    },
    // 新建
    addServe() {
      this.isShowDialog = true;
      this.dialogTitle = "创建员工";
      this.dialogType = "add";
      this.getSexStatusLists();
      this.getStatusValLists();
      this.getConfDictValDownListGroupName();
      this.getConfDictValDownListJobName();
    },
    // 编辑
    editEmployee(data) {
      this.isShowDialog = true;
      this.dialogTitle = "编辑员工";
      this.dialogType = "edit";

      this.dialogForm = data;
      console.log("dialogForm", this.dialogForm);
      this.getSexStatusLists();
      this.getStatusValLists();
      this.getConfDictValDownListGroupName();
      this.getConfDictValDownListJobName();
    },
    // 删除
    delBtns(row) {
      let ids = [row.employeeId];
      this.$confirm("是否删除员工:" + row.employeeName + "?", "提示:").then(
        (res) => {
          this.$API.wtl_delEmployee({ employeeIds: ids }).then((res) => {
            this.$message.success(res.data.message || "删除成功");
            this.getData();
          });
        }
      );
    },

    // 编辑

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    //=>选择表格操作
    handleSelectionChange(e) {
      this.selectMemberData = e;
    },
    //表格样式i
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
    },
    /**
     * ******************************计算表格高度**开始*************************
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 10; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      let formData = {
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        deptId: this.queryData.deptId, //部门id
        employeeName: this.queryData.employeeName, //姓名
        jobNumber: this.queryData.jobNumber, //工号
      };
      this.$API.wtl_getEmployeeList(formData).then((res) => {
        that.tableData = res.data.result.data || [];
        that.pageCount = res.data.result.pageCount || 0;
        this.className = res.data.result.className || "";
        this.$nextTick(() => {
          this.fetTableHeight();
        });
      });
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.getDeptList();
      this.dialogForm = {
        employeeName: "",
        employeeStatus: "zai_zhi:employee_status", // zai_zhi:employee_status=在职 li_zhi:employee_status=离职
        sex: "",
        comment: "",
        commissionRate: "", //提成比例
        deptId: "", //部门id
        groupNameConfDictId: "", //组别id
        jobName: "", //职务
        jobNameConfDictId: "", //职位id
        jobNumber: "", //提成比例
        phone: "", //手机
        mail: "", //邮箱
        tel: "", //电话
        sort: "1", //电话
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.jobNameList.forEach((item) => {
            if (item.confDictId == this.dialogForm.jobNameConfDictId) {
              this.dialogForm.jobName = item.key;
            }
          });
          if(!this.dialogForm.jobNameConfDictId){
            this.dialogForm.jobName = ''
          }
          let param = {
            employeeName: this.dialogForm.employeeName || "",
            employeeStatus: this.dialogForm.employeeStatus || "",
            sex: this.dialogForm.sex || "",
            comment: this.dialogForm.comment || "",
            commissionRate: this.dialogForm.commissionRate || "",
            deptId: this.dialogForm.deptId || "",
            groupNameConfDictId: this.dialogForm.groupNameConfDictId || "",
            jobName: this.dialogForm.jobName || "",
            jobNameConfDictId: this.dialogForm.jobNameConfDictId || "",
            jobNumber: this.dialogForm.jobNumber || "",
            mail: this.dialogForm.mail || "",
            phone: this.dialogForm.phone || "",
            tel: this.dialogForm.tel || "",
            sort: this.dialogForm.sort || "0",
          };
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addEmployee(param).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.getData();
              this.isShowDialog = false;
              this.resetForm(formName);
            });
          } else {
            // 编辑
            param.employeeId = this.dialogForm.employeeId;
            this.$API.wtl_udpateEmployee(param).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.getData();
              this.isShowDialog = false;
              this.resetForm(formName);
            });
          }
        } else {
          return false;
        }
      });
    },
    // 清空
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    handleCloseDia2() {
      this.isShowDialog2 = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn2() {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isShowDialog2 = false;
          this.resetForm(formName);
        } else {
          return false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn2() {
      this.isShowDialog2 = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="less">
// .containerbox {
//   height: calc(100vh - 75px);
// }

// .tableBox {
//   height: calc(100% - 180px);
// }
.colorStyle {
  color: #f00;
}
.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}
.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}
.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}
.imgbox {
  width: 100%;
  margin-left: 12%;
  box-sizing: border-box;
}
.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
  }
}
.singleinp1 {
  min-width: 392px;
}
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}
.SingleChoicebox {
  width: 100%;
  padding: 0 20px;
  margin-top: 20px;
  box-sizing: border-box;
}
.el-input-number {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.serverContent {
  .tableBox {
    background-color: #fff;
  }
  .btnList1 {
    width: auto;
    // padding: 10px;
    border-radius: 4px;
  }
}
</style>
